import styled from "styled-components";

export const Spacer = styled.div`
  margin: ${({ left = 0, right = 0, top = 0, bottom = 0 }) =>
    `${top} ${right} ${bottom} ${left}`};
`;
